import React from "react";
import _ from "underscore";

import "./validationBar.scss";

interface Props {
  errors?: IValidationError[];
}

export const ValidationBar = ({ errors }: Props) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  const message = errors.length <= 1
    ? "There was a problem while saving"
    : "There were some problems while saving";
  return (
    <div className="validation-bar">
      <strong>{message}</strong>
      {(errors || []).map((error, index) => <div key={index}>{error.message}</div>)}
    </div>
  );
};
